var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageTitle":_vm.$t("templates")}},[(_vm.templates.length)?_c('ja-template-deck',{attrs:{"selectableItem":"","items":_vm.templates,"on-click":(item) => _vm.jaDetailView("template", item)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }